import { useLocation } from "react-router-dom";

/**
 * A very light fade-in on route change. Keyed on `pathname` so React remounts
 * the wrapper — the CSS animation replays on every navigation.
 *
 * The animation is applied via a plain CSS class (defined in index.css) so
 * that `prefers-reduced-motion: reduce` can disable it without JS. The
 * initial opacity is not 0 — we start at 0.001 with the animation set to
 * `both` so first paint shows the content immediately if animation is
 * disabled, and the animation resolves to opacity 1 either way.
 */
export function PageTransition({ children }) {
  const { pathname } = useLocation();
  return (
    <div key={pathname} className="page-transition">
      {children}
    </div>
  );
}
